/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import { useCallback, useEffect, useState } from "react";
import { connect } from "react-redux";
import Select from "react-select";

// Dashboard components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";

// Dashboard example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import Tooltip from "@mui/material/Tooltip";

// Notification
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Functions from store
import {
  createDynamicColumn,
  getDynamicColumn,
  getLevel1ByLevel,
  getLevel2ByLevel,
  getLevel3ByLevel,
  getLevel4ByLevel,
  getSubModulesByRoleId,
  getSuids,
  getWarehouseOccupancy,
  getWarehouseOccupancyDownload,
  getWarehouses,
} from "../../../store";

import { CSVLink } from "react-csv";

// Cookies
import { Backdrop, CircularProgress } from "@mui/material";
import Cookies from "universal-cookie";

import CloseIcon from "@mui/icons-material/Close";
import Alert from "@mui/material/Alert";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";
import MDCard from "components/MDCard";
import { addMinutes, format } from "date-fns";

import Config from "../../../config/index";

const cookies = new Cookies();
const desLength = Config.descriptionLength;

const WarehouseOccupancy = ({
  getSubModulesByRoleId,
  getSubModulesByRoleIdReducer,
  warehouses,
  getWarehouses,
  getLevel1ByLevel,
  createDynamicColumn,
  getDynamicColumn,
  getLevel1ByLevelReducer,
  getLevel2ByLevelReducer,
  getLevel3ByLevelReducer,
  getLevel2ByLevel,
  getLevel3ByLevel,
  getWarehouseOccupancyReducer,
  getLevel4ByLevelReducer,
  downloadWarehouseOccupancyReducer,
  getLevel4ByLevel,
  getWarehouseOccupancy,
  getDynamicColumnReducer,
  getWarehouseOccupancyDownload,
}) => {
  let loginDetails = cookies.get("loginDetailsForWMS");
  const styleForColumnReorder = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 380,
    color: "black",
    // border: "2px solid #000",
    boxShadow: 24,
    p: 2,
    pt: 3,
  };

  let jwtToken = loginDetails?.jwt;
  let roleId = loginDetails.data.roleId;

  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);
  useEffect(() => {
    getWarehouses(jwtToken);
  }, []);

  const [pageNo, setPageNo] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchObject, setSearchObject] = useState(JSON.stringify({}));
  const [paginationObj, setPaginationObj] = useState({});
  const [display, setDisplay] = useState("");
  const [errorMsgFromApi, setErrorMsgFromApi] = useState("");

  const importPageNo = (pageIndex) => {
    setPageNo(pageIndex === -1 ? pageNo : pageIndex);
  };

  const importRowsPerPage = (pageSize) => {
    setRowsPerPage(pageSize);
  };

  const importSearch = (globalFilter) => {
    setSearchObject(globalFilter ? JSON.stringify(globalFilter) : "");
  };
  const [refresh, setRefresh] = useState("");
  setTimeout(() => {
    setRefresh(!refresh);
  }, 60000);

  const [modulesData, setModulesData] = useState([]);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : [],
    );
  }, [getSubModulesByRoleIdReducer]);

  let warehouseOccupancyModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "6a523539-2422-4e1d-9e5f-3312b5244af2",
  );

  let viewWarehouseOccupancy = warehouseOccupancyModule
    ? warehouseOccupancyModule.actionId.includes(
        "5f6af518-e5b4-4609-aede-49f3efa4abe9",
      )
    : null;

  const [state, setState] = useState({
    columns: [
      { Header: "Item Code", accessor: "itemCode" },
      {
        Header: "Item Description",
        accessor: "itemDescription",
        align: "left",
        width: 320,
      },
      { Header: "Picklist Code", accessor: "picklistCode" },
      { Header: "Item Qty", accessor: "qty" },
      { Header: "Uom", accessor: "uom" },
      { Header: "SKU", accessor: "sku", width: 320 },
      { Header: "SUID", accessor: "suid", width: 320 },
      { Header: "LOT No", accessor: "lotNumber" },
      { Header: "Serial No", accessor: "serialNumber" },
      { Header: "Warehouse", accessor: "warehouseCode" },
      { Header: "Zone", accessor: "zoneCode" },
      { Header: "Section", accessor: "sectionCode" },
      { Header: "Partition", accessor: "partitionCode" },
      { Header: "Location", accessor: "locationCode" },
      {
        Header: "Created Date",

        accessor: "cd",
        align: "left",
        searchType: "date",
        Cell: ({ value }) => {
          return value
            ? format(
                addMinutes(
                  new Date(value),
                  new Date(value).getTimezoneOffset(),
                ),
                "dd/MM/yyyy hh:mm aaa",
              )
            : "";
        },
      },
      {
        Header: "Picklist Delivery  Date",

        accessor: "ud",
        align: "left",
        searchType: "date",
        Cell: ({ value }) => {
          return value
            ? format(
                addMinutes(
                  new Date(value),
                  new Date(value).getTimezoneOffset(),
                ),
                "dd/MM/yyyy hh:mm aaa",
              )
            : "";
        },
      },
    ],
    rows: [],
  });
  const { columns, rows } = state;

  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let tempFinishedGoods = [];
    let data = getWarehouseOccupancyReducer.warehouseOccupancy.data
      ? getWarehouseOccupancyReducer.warehouseOccupancy.data
      : [];

    setDisplay(
      getWarehouseOccupancyReducer.warehouseOccupancy?.whOccupancyTotalItemQty,
    );
    setLoading(getWarehouseOccupancyReducer.loading);

    setPaginationObj(
      getWarehouseOccupancyReducer.warehouseOccupancy?.pagination,
    );
    data?.map((finishedGoods) => {
      const formatDate = new Date(finishedGoods.cd);
      const formatDate1 = new Date(finishedGoods.ud);
      let len = desLength;
      const finishedGoodsObject = {
        itemCode: finishedGoods.itemCode,
        itemDescription: finishedGoods.itemDescription,
        picklistCode: finishedGoods.picklistCode,

        itemDescription: (
          <span style={{ display: "flex", alignItems: "center" }}>
            {finishedGoods?.itemDescription?.length > 35 ? (
              <Tooltip
                title={finishedGoods.itemDescription}
                style={{ cursor: "pointer" }}
              >
                <MDTypography
                  variant="h6"
                  fontWeight="regular"
                  style={{ fontSize: "14px" }}
                >
                  {finishedGoods.itemDescription.substring(0, len)}
                </MDTypography>
              </Tooltip>
            ) : (
              <MDTypography
                variant="h6"
                fontWeight="regular"
                style={{ fontSize: "14px" }}
              >
                {finishedGoods.itemDescription}
              </MDTypography>
            )}
            {finishedGoods?.itemDescription?.length > 35 && (
              <span style={{ marginLeft: "0.1rem" }}>...</span>
            )}
          </span>
        ),

        qty: `${finishedGoods.qty}`,
        uom: `${finishedGoods.uom}`,
        suid: finishedGoods.suid,
        sku: finishedGoods.sku,
        createdDate: format(
          addMinutes(formatDate, formatDate.getTimezoneOffset()),
          "dd/MM/yyyy hh:mm aaa",
        ),
        ud: format(
          addMinutes(formatDate1, formatDate1.getTimezoneOffset()),
          "dd/MM/yyyy hh:mm aaa",
        ),
        ud: finishedGoods.ud,
        cd: finishedGoods.cd,
        serialNumber: `${
          finishedGoods.serialNumber ? finishedGoods.serialNumber : "NA"
        }`,
        lotNumber: `${
          finishedGoods.lotNumber ? finishedGoods.lotNumber : "NA"
        }`,
        warehouseCode: finishedGoods.warehouseCode,
        zoneCode: finishedGoods.zoneCode,
        sectionCode: finishedGoods.sectionCode,
        partitionCode: finishedGoods.partitionCode,
        locationCode: finishedGoods.locationCode,
      };
      tempFinishedGoods.push(finishedGoodsObject);
    });
    setState({ ...state, rows: tempFinishedGoods });
  }, [getWarehouseOccupancyReducer]);

  const [Download, setDownload] = useState("");
  useEffect(() => {
    let tempFinishedGoods = [];
    let data = downloadWarehouseOccupancyReducer.warehouseOccupancy.data
      ? downloadWarehouseOccupancyReducer.warehouseOccupancy.data
      : [];
    data?.map((finishedGoods) => {
      const formatDate = new Date(finishedGoods.cd);
      const formatDate1 = new Date(finishedGoods.ud);
      const finishedGoodsObject = {
        itemCode: finishedGoods.itemCode,
        itemDescription: finishedGoods.itemDescription,
        picklistCode: finishedGoods.picklistCode,
        qty: `${finishedGoods.qty}`,
        uom: `${finishedGoods.uom}`,
        suid: finishedGoods.suid,
        sku: finishedGoods.sku,
        createdDate: format(
          addMinutes(formatDate, formatDate.getTimezoneOffset()),
          "dd/MM/yyyy hh:mm aaa",
        ),

        createdDate2: format(
          addMinutes(formatDate1, formatDate1.getTimezoneOffset()),
          "dd/MM/yyyy hh:mm aaa",
        ),
        ud: finishedGoods.ud,
        cd: finishedGoods.cd,
        lotSerialNo: `${
          finishedGoods.lotNumber ? finishedGoods.lotNumber : "NA"
        } / ${finishedGoods.serialNumber ? finishedGoods.serialNumber : "NA"}`,
        serialNumber: `${
          finishedGoods.serialNumber ? finishedGoods.serialNumber : "NA"
        }`,
        lotNumber: `${
          finishedGoods.lotNumber ? finishedGoods.lotNumber : "NA"
        }`,
        warehouse: finishedGoods.warehouseCode,
        zone: finishedGoods.zoneCode,
        section: finishedGoods.sectionCode,
        partition: finishedGoods.partitionCode,
        location: finishedGoods.locationCode,
      };
      tempFinishedGoods.push(finishedGoodsObject);
    });
    setDownload(tempFinishedGoods);
  }, [downloadWarehouseOccupancyReducer]);

  const headers = [
    {
      label: "itemCode",
      key: "itemCode",
    },
    {
      label: "itemDescription",
      key: "itemDescription",
    },
    {
      label: "Picklist Code",
      key: "picklistCode",
    },
    { label: "Item qty", key: "qty" },
    {
      label: "uom",
      key: "uom",
    },
    {
      label: "sku",
      key: "sku",
    },
    {
      label: "suid",
      key: "suid",
    },
    { label: "LOT No", key: "lotNumber" },
    { label: "serial No", key: "serialNumber" },
    { label: "warehouse", key: "warehouse" },
    { label: "zone", key: "zone" },
    { label: "section", key: "section" },
    { label: "partition", key: "partition" },
    { label: "location", key: "location" },
    // { label: "l1Remarks", key: "l1Remarks" },
    // { label: "l2Remarks", key: "l2Remarks" },
    { label: "createdDate", key: "createdDate" },
    { label: "Picklist Delivery Date", key: "createdDate2" },
  ];
  const csvLink = {
    filename: "Warehouse Occupancy Report.csv",
    headers: headers,
    data: Download,
  };
  const [warehouseOptions, setWarehouseOptions] = useState([]);
  useEffect(() => {
    let tempWarehouseOptions = [];
    let data = warehouses.warehouses ? warehouses.warehouses : [];
    data.map((warehouse) => {
      tempWarehouseOptions.push({
        label: warehouse.warehouseCode,
        value: warehouse.warehouseId,
        key: warehouse.warehouseCode,
      });
    });
    setWarehouseOptions(tempWarehouseOptions);
  }, [warehouses]);
  const [level1Options, setLevel1Options] = useState([]);

  useEffect(() => {
    let tempLevelOptions = [];
    let data = getLevel1ByLevelReducer.level1ByLevel.data
      ? getLevel1ByLevelReducer.level1ByLevel.data
      : [];
    data.map((level) => {
      tempLevelOptions.push({
        label: level.locationName,
        value: level.locationId,
        key: level.locationName,
      });
    });

    setLevel1Options(tempLevelOptions);
  }, [getLevel1ByLevelReducer]);

  const [level2Options, setLevel2Options] = useState([]);

  useEffect(() => {
    let tempLevelOptions = [];
    let data = getLevel2ByLevelReducer.level2ByLevel.data
      ? getLevel2ByLevelReducer.level2ByLevel.data
      : [];

    data.map((level) => {
      tempLevelOptions.push({
        label: level.locationName,
        value: level.locationId,
      });
    });

    setLevel2Options(tempLevelOptions);
  }, [getLevel2ByLevelReducer]);

  const [level3Options, setLevel3Options] = useState([]);

  useEffect(() => {
    let tempLevelOptions = [];
    let data = getLevel3ByLevelReducer.level3ByLevel.data
      ? getLevel3ByLevelReducer.level3ByLevel.data
      : [];

    data.map((level) => {
      tempLevelOptions.push({
        label: level.locationName,
        value: level.locationId,
      });
    });

    setLevel3Options(tempLevelOptions);
  }, [getLevel3ByLevelReducer]);

  const [level4Options, setLevel4Options] = useState([]);

  useEffect(() => {
    let tempLevelOptions = [];
    let data = getLevel4ByLevelReducer.level4ByLevel.data
      ? getLevel4ByLevelReducer.level4ByLevel.data
      : [];

    data.map((level) => {
      tempLevelOptions.push({
        label: level.locationName,
        value: level.locationId,
      });
    });

    setLevel4Options(tempLevelOptions);
  }, [getLevel4ByLevelReducer]);

  const subModuleId = "6a523539-2422-4e1d-9e5f-3312b5244af2";
  let dynamicColumnDetails = cookies.get("dynamic-column-data");
  let userId = loginDetails.data.userId;
  let hiddenColumsDetails = cookies.get("hidden-column-data");

  useEffect(() => {
    getDynamicColumn(userId, subModuleId, jwtToken);
  }, [userId, subModuleId]);
  const [loadingForDynamicColumn, setLoadingForDynamicColumn] = useState(false);
  useEffect(() => {
    let data = getDynamicColumnReducer.dynamicColumn.data
      ? getDynamicColumnReducer.dynamicColumn.data
      : [];

    setDynamicColumnData(data);
    cookies.set("hidden-column-data", JSON.stringify(data?.notVisibleFields), {
      path: "/",
    });

    setTimeout(() => {
      setLoadingForDynamicColumn(true);
    }, 1000);
  }, [getDynamicColumnReducer, loading]);

  const [openCreateColumnReorderModal, setOpenCreateColumnReorderModal] =
    useState(false);

  const handleOpenCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(true);
  };

  const handleCloseCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(false);
  };

  const [dynamicColumnData, setDynamicColumnData] = useState("");
  const [isErrorColumnReorder, setIsErrorColumnReorder] = useState(false);
  const [isSuccessColumnReorder, setIsSuccessColumnReorder] = useState(false);

  useEffect(() => {
    if (isErrorColumnReorder) {
      setTimeout(() => {
        setIsErrorColumnReorder(false);
      }, 3000);
    }
  }, [isErrorColumnReorder]);

  useEffect(() => {
    if (isSuccessColumnReorder) {
      setTimeout(() => {
        setIsSuccessColumnReorder(false);
      }, 3000);
    }
  }, [isSuccessColumnReorder]);

  const [isErrorMsgForColumnReorder, setIsErrorMsgForColumnReorder] =
    useState(false);

  const handleDynamicColumn = async () => {
    let res = await createDynamicColumn(dynamicColumnDetails, jwtToken);
    if (res.status) {
      setIsSuccessColumnReorder(true);
      getDynamicColumn(userId, subModuleId, jwtToken);

      getWarehouseOccupancy(
        pageNo,
        rowsPerPage,
        searchObject,
        concatenatedLocation,
        warehousesCodesx,
        jwtToken,
      );

      setTimeout(() => {
        handleCloseCreateColumnReorderModal();
        // window.location.reload();
      }, 2250);
    }
    if (!res.status) {
      setIsErrorColumnReorder(true);
      setIsErrorMsgForColumnReorder(res?.data?.data?.msg);
    }
  };

  const [selectedOptions, setSelectedOptions] = useState({
    warehouse: [], // now an array
    zone: null,
    section: null,
    rack: null,
    location: null,
  });

  const isMultiWarehouse =
    Array.isArray(selectedOptions.warehouse) &&
    selectedOptions.warehouse.length > 1;

  const warehousesCodesx = Array.isArray(selectedOptions.warehouse)
    ? selectedOptions.warehouse.map((w) => w.label).join(",")
    : selectedOptions.warehouse?.label;

  const zones = Array.isArray(selectedOptions.zone)
    ? selectedOptions.zone.map((z) => z.label).join(",")
    : selectedOptions.zone?.label;

  const concatenatedLocation = isMultiWarehouse
    ? warehousesCodesx // Only show selected warehousesCodesx
    : [
        warehousesCodesx,
        zones,
        selectedOptions.section?.label,
        selectedOptions.rack?.label,
        selectedOptions.location?.label,
      ]
        .filter(Boolean)
        .join("-");

  useEffect(() => {
    getWarehouseOccupancy(
      pageNo,
      rowsPerPage,
      searchObject,
      concatenatedLocation,
      warehousesCodesx,
      jwtToken,
    );
  }, [
    pageNo,
    rowsPerPage,
    searchObject,
    concatenatedLocation,
    warehousesCodesx,
    // getWarehouseOccupancy,
  ]);
  useEffect(() => {
    getWarehouseOccupancyDownload(
      pageNo,
      rowsPerPage,
      searchObject,
      concatenatedLocation,
      warehousesCodesx,
      jwtToken,
    );
  }, [
    pageNo,
    rowsPerPage,
    searchObject,
    concatenatedLocation,
    warehousesCodesx,
  ]);

  const handleChange = (level, newValue) => {
    setSelectedOptions((prevState) => {
      const newState = { ...prevState, [level]: newValue };

      const isMultiWarehouse =
        level === "warehouse" && Array.isArray(newValue) && newValue.length > 1;

      if (level === "warehouse") {
        newState.zone = null;
        newState.section = null;
        newState.rack = null;
        newState.location = null;

        if (Array.isArray(newValue) && newValue.length > 1) {
          newState.zone = null;
          newState.section = null;
          newState.rack = null;
          newState.location = null;
        }
      }

      if (isMultiWarehouse) {
        newState.zone = null;
        newState.section = null;
        newState.rack = null;
        newState.location = null;
      }

      if (level === "zone" && !isMultiWarehouse) {
        newState.section = null;
        newState.rack = null;
        newState.location = null;
      }

      if (level === "section") {
        newState.rack = null;
        newState.location = null;
      }

      if (level === "rack") {
        newState.location = null;
      }

      return newState;
    });
  };

  const fetchLevelData = useCallback(() => {
    const { warehouse, zone, section, rack } = selectedOptions;

    const warehouseList = Array.isArray(warehouse) ? warehouse : [warehouse];

    if (warehouseList.length !== 1) return; // Abort if not exactly 1

    const selectedWarehouse = warehouseList[0];

    if (selectedWarehouse)
      getLevel1ByLevel(selectedWarehouse.value, 0, jwtToken);

    if (selectedWarehouse && zone) {
      const zoneList = Array.isArray(zone) ? zone : [zone];
      zoneList.forEach((z) => {
        getLevel2ByLevel(selectedWarehouse.value, z.value, jwtToken);
      });
    }

    if (selectedWarehouse && section)
      getLevel3ByLevel(selectedWarehouse.value, section.value, jwtToken);

    if (selectedWarehouse && rack)
      getLevel4ByLevel(selectedWarehouse.value, rack.value, jwtToken);
  }, [
    selectedOptions,
    getLevel1ByLevel,
    getLevel2ByLevel,
    getLevel3ByLevel,
    getLevel4ByLevel,
    jwtToken,
  ]);

  useEffect(() => {
    fetchLevelData();
  }, [fetchLevelData]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={0} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                display="flex"
                flexDirection={{ xs: "column", lg: "row" }}
                justifyContent="space-between"
                alignItems="center"
                p={3}
                mb={-3}
                mt={-4}
              >
                <Grid container spacing={1}>
                  <Grid item xs={12} lg={12}>
                    <MDBox>
                      <MDBox
                        display="flex"
                        mt={2}
                        flexDirection={{ xs: "column", lg: "row" }}
                      >
                        {[
                          {
                            label: "Warehouse",
                            value: "warehouse",
                            options: warehouseOptions,
                          },
                          {
                            label: "Zone",
                            value: "zone",
                            options: level1Options,
                            dependsOn: "warehouse",
                          },
                          {
                            label: "Section",
                            value: "section",
                            options: level2Options,
                            dependsOn: "zone",
                          },
                          {
                            label: "Partition",
                            value: "rack",
                            options: level3Options,
                            dependsOn: "section",
                          },
                          {
                            label: "Location",
                            value: "location",
                            options: level4Options,
                            dependsOn: "rack",
                          },
                        ].map(({ label, value, options, dependsOn }) => (
                          <MDBox
                            key={value}
                            width={{
                              xs: "100%",
                              lg: value === "warehouse" ? "420px" : "330px", // Increase Warehouse width, reduce Zone width
                            }}
                            style={{ marginRight: "10px" }}
                          >
                            <MDTypography
                              variant="h6"
                              style={{ fontWeight: 500 }}
                            >
                              {label}
                            </MDTypography>
                            <Select
                              isMulti={value === "warehouse"}
                              isClearable
                              isDisabled={
                                value !== "warehouse" &&
                                ((dependsOn && !selectedOptions[dependsOn]) ||
                                  (value === "zone" &&
                                    (!selectedOptions.warehouse ||
                                      (Array.isArray(
                                        selectedOptions.warehouse,
                                      ) &&
                                        selectedOptions.warehouse.length !==
                                          1))) ||
                                  (value !== "zone" &&
                                    Array.isArray(selectedOptions.warehouse) &&
                                    selectedOptions.warehouse.length > 1))
                              }
                              placeholder="Choose One ..."
                              className="select-css-for-filter"
                              maxMenuHeight={380}
                              autoComplete="off"
                              value={selectedOptions[value]}
                              options={options}
                              onChange={(newValue) =>
                                handleChange(value, newValue)
                              }
                            />
                          </MDBox>
                        ))}
                        <Grid>
                          <MDBox
                            color="text"
                            px={0}
                            display="flex"
                            flexDirection="column"
                          >
                            <MDBox
                              display="flex"
                              marginLeft={1}
                              marginTop="1.6rem"
                            >
                              <CSVLink {...csvLink}>
                                <Tooltip title="Download All Data">
                                  <MDButton
                                    type="button"
                                    variant="outlined"
                                    style={{ borderRadius: "5px" }}
                                    size="small"
                                    color="success"
                                    iconOnly
                                  >
                                    <Icon>download</Icon>
                                  </MDButton>
                                </Tooltip>
                              </CSVLink>
                            </MDBox>
                          </MDBox>
                        </Grid>
                      </MDBox>
                    </MDBox>
                  </Grid>
                </Grid>
              </MDBox>
              <MDTypography
                variant="h5"
                fontWeight="medium"
                flexGrow={1}
                style={{ marginTop: "1rem", marginLeft: "2rem" }}
              >
                Total Available Qty :{display}
              </MDTypography>
              <Modal
                open={openCreateColumnReorderModal}
                onClose={handleCloseCreateColumnReorderModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                style={{ backdropFilter: "blur(5px)" }}
              >
                <MDCard sx={styleForColumnReorder}>
                  <MDTypography>Are you sure you want to submit?</MDTypography>
                  <MDBox mt={2}>
                    <MDButton
                      style={{ width: "10rem", marginRight: "0.5rem" }}
                      color="info"
                      variant="outlined"
                      onClick={handleCloseCreateColumnReorderModal}
                    >
                      Cancel
                    </MDButton>
                    <MDButton
                      style={{ width: "10rem", marginLeft: "0.5rem" }}
                      color="success"
                      onClick={handleDynamicColumn}
                      // disabled={denyButtonName === "Please wait..."}
                    >
                      Submit
                    </MDButton>
                  </MDBox>
                  <MDBox mt={2}>
                    <Collapse in={isSuccessColumnReorder}>
                      <Alert
                        severity="success"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsSuccessColumnReorder(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        Data updated successfully!
                      </Alert>
                    </Collapse>
                    <Collapse in={isErrorColumnReorder}>
                      <Alert
                        severity="error"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsErrorColumnReorder(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        {isErrorMsgForColumnReorder}
                      </Alert>
                    </Collapse>
                  </MDBox>
                </MDCard>
              </Modal>

              <MDBox pt={-1}>
                {loadingForDynamicColumn && (
                  <DataTable
                    table={{ columns, rows }}
                    isSorted={true}
                    tableSearch={true}
                    entriesPerPage={{
                      defaultValue: 10,
                      entries: [10, 15, 20, 25, 30],
                    }}
                    showTotalEntries={true}
                    noEndBorder
                    serverSidePagination={true}
                    paginationObj={paginationObj}
                    pageNoValue={pageNo}
                    rowsPerPageValue={rowsPerPage}
                    pageNoProp={importPageNo}
                    rowsPerPageProp={importRowsPerPage}
                    searchProp={importSearch}
                    loading={loading}
                    hideColumns={hiddenColumsDetails}
                    visibleColumns2={dynamicColumnData?.visibleFields}
                    dynamicColumnData={dynamicColumnData}
                    handleOpenCreateColumnReorderModal={
                      handleOpenCreateColumnReorderModal
                    }
                    subModuleId={subModuleId}
                    userId={userId}
                  />
                )}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      {loading && (
        <Backdrop
          sx={{ color: "blue", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      <ToastContainer />
      {/* {loading && (
        <Backdrop
          sx={{ color: "blue", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )} */}
    </DashboardLayout>
  );
};

const mapStateToProps = (state) => {
  return {
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,

    getSuidsReducer: state.getSuidsReducer,
    warehouses: state.warehouses,
    getLevel1ByLevelReducer: state.getLevel1ByLevelReducer,
    getLevel2ByLevelReducer: state.getLevel2ByLevelReducer,
    getLevel3ByLevelReducer: state.getLevel3ByLevelReducer,
    getLevel4ByLevelReducer: state.getLevel4ByLevelReducer,
    getWarehouseOccupancyReducer: state.getWarehouseOccupancyReducer,
    downloadWarehouseOccupancyReducer: state.downloadWarehouseOccupancyReducer,

    getDynamicColumnReducer: state.getDynamicColumnReducer,
  };
};

const mapStateToDispatch = (dispatch) => {
  return {
    getSubModulesByRoleId: (roleId, jwtToken) =>
      dispatch(getSubModulesByRoleId(roleId, jwtToken)),

    getSuids: (itemId, jwtToken) => dispatch(getSuids(itemId, jwtToken)),
    getWarehouses: (jwtToken) => dispatch(getWarehouses(jwtToken)),
    getWarehouseOccupancy: (
      pageNo,
      rowsPerPage,
      searchObject,
      concatenatedLocation,
      warehousesCodesx,
      jwtToken,
    ) =>
      dispatch(
        getWarehouseOccupancy(
          pageNo,
          rowsPerPage,
          searchObject,
          concatenatedLocation,
          warehousesCodesx,
          jwtToken,
        ),
      ),
    getWarehouseOccupancyDownload: (
      pageNo,
      rowsPerPage,
      searchObject,
      concatenatedLocation,
      jwtToken,
    ) =>
      dispatch(
        getWarehouseOccupancyDownload(
          pageNo,
          rowsPerPage,
          searchObject,
          concatenatedLocation,
          jwtToken,
        ),
      ),
    getLevel1ByLevel: (dWarehouseSelected, parentId, jwtToken) =>
      dispatch(getLevel1ByLevel(dWarehouseSelected, parentId, jwtToken)),
    getLevel2ByLevel: (warehouseId, parentId, jwtToken) =>
      dispatch(getLevel2ByLevel(warehouseId, parentId, jwtToken)),
    getLevel3ByLevel: (warehouseId, parentId, jwtToken) =>
      dispatch(getLevel3ByLevel(warehouseId, parentId, jwtToken)),
    getLevel4ByLevel: (warehouseId, parentId, jwtToken) =>
      dispatch(getLevel4ByLevel(warehouseId, parentId, jwtToken)),
    getDynamicColumn: (userId, subModuleId, jwtToken) =>
      dispatch(getDynamicColumn(userId, subModuleId, jwtToken)),
    createDynamicColumn: (payload, jwtToken) =>
      dispatch(createDynamicColumn(payload, jwtToken)),
  };
};

export default connect(mapStateToProps, mapStateToDispatch)(WarehouseOccupancy);
